export const images = {
  hero: 'https://cdn.magicpatterns.com/uploads/gm8Nkua8EoGSe8eR8VHH3x/Imagen_de_ChatGPT_5_oct_2026,_09_51_43_p.m.png',
  problem: 'https://cdn.magicpatterns.com/uploads/jjUXC3FyG6dWidjx183ooS/Imagen_de_ChatGPT_5_oct_2026,_09_49_52_p.m.png',
  results: 'https://cdn.magicpatterns.com/uploads/hunm7w6thmee5854JiKFNq/copy_9AF922F3-CC4B-43DD-BDE5-FD6DF2C9A0F3.jpg',
  coachTransformation: 'https://cdn.magicpatterns.com/uploads/wjpBbWb4hWzrBewpTknjLd/copy_3AA14C0E-3A42-493B-A2DF-FDDCB1EBAF37.jpg',
  realLife: 'https://cdn.magicpatterns.com/patterns/generated-images/93cc0f8b-3210-46bf-845c-0ff9cd27fc57.jpg',
  coach: 'https://cdn.magicpatterns.com/patterns/generated-images/188d2d67-b1cf-4511-bfc1-14d14cb255be.jpg',
}
